import React from "react";
import PropTypes from "prop-types";
import {
  TT_SQUARE_AD,
  TT_PORTRAIT_AD,
  SS_SQUARE_AD,
  SS_PORTRAIT_AD,
  TT_COMPS_SQUARE_AD,
  TT_COMPS_PORTRAIT_AD,
  TCM_PORTRAIT_AD,
  TCM_SQUARE_AD,
  NX_SQUARE_AD,
} from "../../../data/adverts";
import * as breakpoints from "../../../../app/data/breakpoints";
import staticUrl from "../../../utils/staticPath";

const Advert = ({ advert }) => {
  const getAdvert = (ad) => {
    const advertImgPath = `${staticUrl()}assets/images/raster/adverts/`;
    let advertObj = {};

    let ttHref = `https://www.toptekkers.club/?utm_source=tcm-advert&utm_medium=mobilewebsite`;
    if (window.matchMedia(`(min-width: ${breakpoints.SMALL}px)`).matches) {
      ttHref = `https://www.toptekkers.club/?utm_source=tcm-advert&utm_medium=desktopwebsite`;
    }
    const ttCompsHref = `https://content.thecoachingmanual.com/blog/toptekkers-championships`;
    const tcmHref = `https://app.thecoachingmanual.com/signup`;
    const nexusHref = `https://content.thecoachingmanual.com/blog/nexus-where-philosophy-methodology-and-people-connect`;

    switch (ad) {
      case TCM_SQUARE_AD:
        advertObj = {
          src: `${advertImgPath}TCM_Square_Ad.png`,
          alt: `The Coaching Manual advert`,
          href: tcmHref,
        };
        break;
      case TCM_PORTRAIT_AD:
        advertObj = {
          src: `${advertImgPath}TCM_Portrait_Ad.png`,
          alt: `The Coaching Manual advert`,
          href: tcmHref,
        };
        break;
      case NX_SQUARE_AD:
        advertObj = {
          src: `${advertImgPath}NX_Square_Ad.png`,
          alt: `Nexus powered by The Coaching Manual advert`,
          href: nexusHref,
        };
        break;
      case TT_SQUARE_AD:
        advertObj = {
          src: `${advertImgPath}TT_Square_Ad.jpg`,
          alt: `TopTekkers Soccer advert`,
          href: ttHref,
        };
        break;
      case TT_PORTRAIT_AD:
        advertObj = {
          src: `${advertImgPath}TT_Portrait_Ad.jpg`,
          alt: `TopTekkers Soccer advert`,
          href: ttHref,
        };
        break;
      case TT_COMPS_SQUARE_AD:
        advertObj = {
          src: `${advertImgPath}TT_Comps_Square_Ad.jpg`,
          alt: `TopTekkers North American Championships`,
          href: ttCompsHref,
        };
        break;
      case TT_COMPS_PORTRAIT_AD:
        advertObj = {
          src: `${advertImgPath}TT_Comps_Portrait_Ad.jpg`,
          alt: `TopTekkers North American Championships`,
          href: ttCompsHref,
        };
        break;
      case SS_SQUARE_AD:
        advertObj = {
          src: `${advertImgPath}SS_Square_Ad.jpg`,
          alt: `Sensilbe Soccer advert`,
          href: `https://sensiblesoccer.co.uk/`,
        };
        break;
      case SS_PORTRAIT_AD:
        advertObj = {
          src: `${advertImgPath}SS_Portrait_Ad.jpg`,
          alt: `Sensilbe Soccer advert`,
          href: `https://sensiblesoccer.co.uk/`,
        };
        break;

      default:
        advertObj = {
          src: `${advertImgPath}TT_Square_Ad.jpg`,
          alt: `TopTekkers Soccer advert`,
          href: `https://toptekkers.club/`,
        };
    }

    return advertObj;
  };

  const advertObj = getAdvert(advert);

  return (
    <div className="advert">
      {advertObj !== null && (
        <a href={advertObj.href} target="_blank" rel="”noopener”">
          <img src={advertObj.src} alt={advertObj.alt} />
        </a>
      )}
    </div>
  );
};

Advert.propTypes = {
  advert: PropTypes.string,
};

export default Advert;



// WEBPACK FOOTER //
// ./library/app/components/Global/Adverts/Advert.js